import { render, staticRenderFns } from "./TheAside.vue?vue&type=template&id=0101f5c2&"
import script from "./TheAside.vue?vue&type=script&lang=js&"
export * from "./TheAside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports